import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-component',
  templateUrl: 'confirm.component.html'
})

export class ConfirmComponent {
  public confirmMessage: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      if (data.confirmMessage) {
        this.confirmMessage = data.confirmMessage;
      }
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/confirm/confirm.component.ts